import script from "./ConstructorAttachments.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructorAttachments.vue?vue&type=script&setup=true&lang=js"

import "./ConstructorAttachments.vue?vue&type=style&index=0&id=334f4c85&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334f4c85"]])

export default __exports__